import { ReferralStatus } from '$constants/ReferralStatus';
import { userLanguage, ValidLanguages } from '$translations/index';
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { errorHandler, successHandler } from '../../../utils';
import {
  CandidateReferralBuilder,
  CandidateReferralRequestInput,
} from '../candidate-referrals.types';

export const sendReferralRequest = (builder: CandidateReferralBuilder) =>
  builder.mutation<void, CandidateReferralRequestInput>({
    query: ({ candidateId, ReferralEmail }) => ({
      url: `candidate-referrals/candidate/${candidateId}`,
      method: 'POST',
      body: {
        ReferralEmail,
        Status: ReferralStatus.PENDING,
      },
    }),
    invalidatesTags: ['CandidateReferrals'],
    transformResponse: () => {
      successHandler(
        userLanguage === ValidLanguages.es
          ? SuccessMessageEs.ReferenceRequestSentSuccessfully
          : SuccessMessageEn.ReferenceRequestSentSuccessfully,
        true
      );
    },
    transformErrorResponse: (error, meta, args) => {
      if (error.status === 409) {
        errorHandler(
          '[SendReferralRequest]',
          `A pending reference with the email ${args.ReferralEmail} already exists for this candidate`,
          error.data,
          true
        );
      } else {
        errorHandler(
          '[SendReferralRequest]',
          userLanguage === 'es'
            ? ErrorMessageEs.InfoFail
            : ErrorMessageEn.InfoFail,
          error,
          true
        );
      }
    },
  });
